import { createDemo } from '@mui/internal-core-docs/utils/createDemo';
import CssLayersCaveat from './CssLayersCaveat';
import ClientProvider from './client';
export default createDemo(import.meta.url, CssLayersCaveat, { ClientProvider, precompute: {
  "Default": {
    "url": "file:///opt/build/repo/docs/data/material/customization/css-layers/demos/caveat/CssLayersCaveat.tsx",
    "fileName": "CssLayersCaveat.tsx",
    "language": "tsx",
    "source": {
      "type": "root",
      "children": [
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "import * as React from 'react';\nimport { createTheme, ThemeProvider } from '@mui/material/styles';\nimport Accordion from '@mui/material/Accordion';\nimport AccordionSummary from '@mui/material/AccordionSummary';\nimport AccordionDetails from '@mui/material/AccordionDetails';\nimport Typography from '@mui/material/Typography';\nimport ExpandMoreIcon from '@mui/icons-material/ExpandMore';\nimport Box from '@mui/material/Box';\nimport Switch from '@mui/material/Switch';\n\nexport default function CssLayersCaveat() {\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "dataFrameType": "focus-unfocused",
            "dataFrameIndent": 1,
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "  const [cssLayers, setCssLayers] = React.useState(false);\n  const theme = React.useMemo(() => {\n    return createTheme({\n      modularCssLayers: cssLayers,\n      components: {\n        MuiAccordion: {\n          styleOverrides: {\n            root: {\n              margin: 0,\n            },\n          },\n        },\n      },\n    });\n  }, [cssLayers]);\n  return (\n    <div>\n      <Box\n        sx={{\n          display: 'flex',\n          alignItems: 'center',\n          justifyContent: 'center',\n          marginBottom: '16px',\n        }}\n      >\n        <Typography\n          component=\"span\"\n          sx={{ marginRight: '8px', fontSize: '14px', color: 'text.secondary' }}\n        >\n          No CSS Layers\n        </Typography>\n        <Switch checked={cssLayers} onChange={() => setCssLayers(!cssLayers)} />\n        <Typography\n          component=\"span\"\n          sx={{ marginLeft: '8px', fontSize: '14px', color: 'text.secondary' }}\n        >\n          With CSS Layers\n        </Typography>\n      </Box>\n      <ThemeProvider theme={theme}>\n        <div>\n          <Accordion defaultExpanded>\n            <AccordionSummary\n              expandIcon={<ExpandMoreIcon />}\n              aria-controls=\"panel1-content\"\n              id=\"panel1-header\"\n            >\n              <Typography component=\"span\">Accordion 1</Typography>\n            </AccordionSummary>\n            <AccordionDetails>\n              Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse\n              malesuada lacus ex, sit amet blandit leo lobortis eget.\n            </AccordionDetails>\n          </Accordion>\n          <Accordion>\n            <AccordionSummary\n              expandIcon={<ExpandMoreIcon />}\n              aria-controls=\"panel2-content\"\n              id=\"panel2-header\"\n            >\n              <Typography component=\"span\">Accordion 2</Typography>\n            </AccordionSummary>\n            <AccordionDetails>\n              Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse\n              malesuada lacus ex, sit amet blandit leo lobortis eget.\n            </AccordionDetails>\n          </Accordion>\n        </div>\n      </ThemeProvider>\n    </div>\n  );\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "}\n"
            }
          ]
        }
      ],
      "data": {
        "totalLines": 83,
        "focusedLines": 0,
        "collapsible": true
      }
    },
    "fallback": [
      [
        "span",
        "frame",
        "import * as React from 'react';\nimport { createTheme, ThemeProvider } from '@mui/material/styles';\nimport Accordion from '@mui/material/Accordion';\nimport AccordionSummary from '@mui/material/AccordionSummary';\nimport AccordionDetails from '@mui/material/AccordionDetails';\nimport Typography from '@mui/material/Typography';\nimport ExpandMoreIcon from '@mui/icons-material/ExpandMore';\nimport Box from '@mui/material/Box';\nimport Switch from '@mui/material/Switch';\n\nexport default function CssLayersCaveat() {\n"
      ],
      [
        "span",
        "frame",
        {
          "dataFrameType": "focus-unfocused",
          "dataFrameIndent": 1
        },
        "  const [cssLayers, setCssLayers] = React.useState(false);\n  const theme = React.useMemo(() => {\n    return createTheme({\n      modularCssLayers: cssLayers,\n      components: {\n        MuiAccordion: {\n          styleOverrides: {\n            root: {\n              margin: 0,\n            },\n          },\n        },\n      },\n    });\n  }, [cssLayers]);\n  return (\n    <div>\n      <Box\n        sx={{\n          display: 'flex',\n          alignItems: 'center',\n          justifyContent: 'center',\n          marginBottom: '16px',\n        }}\n      >\n        <Typography\n          component=\"span\"\n          sx={{ marginRight: '8px', fontSize: '14px', color: 'text.secondary' }}\n        >\n          No CSS Layers\n        </Typography>\n        <Switch checked={cssLayers} onChange={() => setCssLayers(!cssLayers)} />\n        <Typography\n          component=\"span\"\n          sx={{ marginLeft: '8px', fontSize: '14px', color: 'text.secondary' }}\n        >\n          With CSS Layers\n        </Typography>\n      </Box>\n      <ThemeProvider theme={theme}>\n        <div>\n          <Accordion defaultExpanded>\n            <AccordionSummary\n              expandIcon={<ExpandMoreIcon />}\n              aria-controls=\"panel1-content\"\n              id=\"panel1-header\"\n            >\n              <Typography component=\"span\">Accordion 1</Typography>\n            </AccordionSummary>\n            <AccordionDetails>\n              Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse\n              malesuada lacus ex, sit amet blandit leo lobortis eget.\n            </AccordionDetails>\n          </Accordion>\n          <Accordion>\n            <AccordionSummary\n              expandIcon={<ExpandMoreIcon />}\n              aria-controls=\"panel2-content\"\n              id=\"panel2-header\"\n            >\n              <Typography component=\"span\">Accordion 2</Typography>\n            </AccordionSummary>\n            <AccordionDetails>\n              Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse\n              malesuada lacus ex, sit amet blandit leo lobortis eget.\n            </AccordionDetails>\n          </Accordion>\n        </div>\n      </ThemeProvider>\n    </div>\n  );\n"
      ],
      [
        "span",
        "frame",
        "}\n"
      ]
    ],
    "totalLines": 83,
    "focusedLines": 0,
    "collapsible": true,
    "externals": [
      "react",
      "@mui/material/styles",
      "@mui/material/Accordion",
      "@mui/material/AccordionSummary",
      "@mui/material/AccordionDetails",
      "@mui/material/Typography",
      "@mui/icons-material/ExpandMore",
      "@mui/material/Box",
      "@mui/material/Switch"
    ]
  }
}, loadPrecompute: () => import("./index.ts?mui-deferred-precompute").then((module) => module.default) });
